import { Box, Chip } from '@mui/material';
import {
  PazaramaOrderStatus,
  pazaramaOrderStatusDescriptionMap,
  pazaramaOrderStatusNameMap,
} from '../../../interfaces/Pazarama/PazaramaOrderStatus';

interface PazaramaStatusCellProps {
  status: PazaramaOrderStatus;
}

export const PazaramaStatusCell = (props: PazaramaStatusCellProps) => {
  const getColor = () => {
    switch (props.status) {
      case PazaramaOrderStatus.CREATED:
        return 'success';
      default:
        return 'error';
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Chip
        size='small'
        variant='filled'
        color={getColor()}
        label={pazaramaOrderStatusNameMap[props.status]}
      />

      <Chip
        size='small'
        variant='filled'
        color={getColor()}
        label={pazaramaOrderStatusDescriptionMap[props.status]}
      />
    </Box>
  );
};
